import { Component, Input, ElementRef, OnInit, OnChanges } from '@angular/core';

type BbButtonType = '' | 'icon-button' | 'round-icon-button';
@Component({
	selector: 'bb-button',
	templateUrl: './bb-button.component.html',
	styleUrls: ['./bb-button.component.scss'],
})

export class BbButtonComponent implements OnInit, OnChanges {
	@Input() active = false;
	@Input() disabled = false;
	@Input() icon: string;
	@Input() iconSize: string;
	@Input() loading = false;
	@Input() type: BbButtonType;
	@Input() theme: 'default' | 'dark' | 'light-v2' | 'rb' = 'default';
	@Input() naked = false;
	@Input() round = false;
	@Input() join: 'left' | 'right';

	// theme 'rb' options
	@Input() backgroundColor?: '' | 'blue' | 'white' | 'red' = '';
	@Input() size?: 'big';
	@Input() pxSize: number;

	el: HTMLElement;

	constructor(private _eref: ElementRef) {
		this.el = this._eref.nativeElement;
	}

	ngOnInit() { }

	ngOnChanges() {
		if (this.disabled) {
			this.el.style.pointerEvents = 'none';
		} else {
			this.el.style.pointerEvents = 'auto';
		}
	}
}
